import axios from 'axios'
import { useInfiniteQuery } from 'react-query'

const API = axios.create()

export const useGetInfinite = ({ key, endpoint, params = {}, config = {} }) => {
  const limit = 10
  return useInfiniteQuery(
    [key, 'list', params],
    async ({ pageParam = 1 }) =>
      (
        await API.get(
          `${endpoint}?page=${pageParam}&limit=${limit}&${new URLSearchParams(params).toString()}`
        )
      ).data,
    {
      getPreviousPageParam: (firstPage) => firstPage.prevPage ?? undefined,
      getNextPageParam: (lastPage) => lastPage.nextPage ?? undefined,
      ...config,
    }
  )
}

export default API
